module.exports = __webpack_public_path__ + "img/ag-badge.a1bb760d.png";